import * as Redux from 'redux';

export class CoachPageActions {
    public static init(): (dispatch: any) => void {
        return (dispatch: any) => {
            dispatch({ type: 'Pages/Coach/Init', payload: null });
        };
    }
}
